
import { getActivityList } from '@/common/js/api.js'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Sticky from 'vux/src/components/sticky/index.vue'


export default {
components: {
Tab,
TabItem,
XHeader,
Box,
XButton,
Group,
CellBox,
Cell,
Scroller,
Icon,
Sticky
},
methods: {













nav(idx) {
this.$router.push({
path: '/activity/detail',
query: { activityId: this.list[idx].activityId }
})
},
refresh() {
let self = this
self.pageInfo.pageIndex = 1
self.getList()
},
loadMore() {
let self = this
self.pageInfo.pageIndex++
self.getList()
},
switchTabItem(index) {

this.$vux.loading.show({
text: 'loading'
})
setTimeout(() => {
this.$vux.loading.hide()
this.index01 = index
}, 1000)
},
onItemClick(index) {
console.log('on item click:', index)
},
getList() {
let self = this
getActivityList({ data: this.pageInfo }).then(function(data) {
self.view.firstLoad = false
if (data.PageIndex > 1) {
self.list = self.list.concat(data.Content)
} else {
self.list = data.Content
}
if (data.Content.length == self.pageInfo.pageSize) {
self.$refs.scroller.enablePullup()
} else {
self.$refs.scroller.disablePullup()
}
setTimeout(() => {
self.$refs.scroller.donePullup()
self.$refs.scroller.donePulldown()
}, 50)
})
}
},
mounted() {},
activated() {

console.log('activated')
this.getList()
},
data() {
return {
view: {
loading: false,
firstLoad: true
},
status: {
pullupStatus: 'default',
pulldownStatus: 'default'
},
pullupConfig: {
content: '上拉加载更多',
downContent: '松开进行加载',
upContent: '上拉加载更多',
loadingContent: '加载中...'
},
pulldownConfig: {
content: '下拉刷新',
downContent: '下拉刷新',
upContent: '释放刷新',
loadingContent: '加载中...'
},
pageInfo: {
pageIndex: 1,
pageSize: 10,
keyword: '',
extInfo: undefined
},
title: '我的订单',
disabled:
typeof navigator !== 'undefined' &&
/iphone/i.test(navigator.userAgent) &&
/ucbrowser/i.test(navigator.userAgent),
list: []
}
}
}



// WEBPACK FOOTER //
// ./src/components/activity/List.vue